import "./Header.css";

function Header() {
    return (
        <header className="fixed-top header">
            <div className="container-lg container-fluid-sm">
                <nav className="navbar navbar-toggleable-sm navbar-expand-md">
                    <a className="navbar-brand logo hide1" href=""></a>
                    <a className="navbar-right1 search hide1" href=""></a>
                    <a className="navbar-right2 cart hide1" href=""></a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarResponsive"
                        aria-controls="navbarResponsive"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    ></button>
                    <div
                        className="navbar-collapse collapse downP"
                        id="navbarResponsive"
                    >
                        <ul className="navbar-nav w-100 nav-fill">
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger logo hide"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger store"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger mac"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger ipad"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger iphone"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger watchh"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger airpodsh"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger tvhome"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger onlyonapple"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger accessories"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link js-scroll-trigger support"
                                    href=""
                                ></a>
                            </li>
                            <li className="nav-item hide">
                                <a className="nav-link search" href=""></a>
                            </li>
                            <li className="nav-item hide">
                                <a className="nav-link cart" href=""></a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    );
}

export default Header;
